var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = { class: "mt-8" };
var _hoisted_2 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-8 text-12px" }, "新しいパスワードを入力してください。", -1);
var _hoisted_3 = { class: "mt-8" };
var _hoisted_4 = {
    key: 0,
    class: "ml-6 mt-4 text-feed-red text-12px font-bold"
};
var _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "mt-4 text-12px" }, " ※パスワードは8文字以上の大文字、数字をそれぞれ1文字以上含む半角英数字記号を入力してください ", -1);
var _hoisted_6 = { class: "flex justify-center mt-8" };
var _hoisted_7 = { class: "mr-8" };
import { ref, reactive, computed } from 'vue';
import Snackbars from '../molecules/Snackbars.vue';
import InputPassword from '../atoms/inputPassword.vue';
import Button from '../atoms/Button.vue';
import LoadingProcessing from '../atoms/LoadingProcessing.vue';
import AlertDialog from '../atoms/AlertDialog.vue';
import { useAcknowledgementStore, useProfileStore } from "../../store";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ResetPasswordForm',
    props: {
    // プロパティの定義
    },
    emits: [
    // イベントの定義
    ],
    setup: function (__props, _a) {
        var _this = this;
        var emits = _a.emit;
        var props = __props;
        var profileStore = useProfileStore();
        var acknowledgementStore = useAcknowledgementStore();
        var pageURL = new URL(window.location.href);
        var params = pageURL.searchParams;
        var cid = params.get('customer_id');
        var token = params.get('reset_password_token');
        var isProcessing = ref(false);
        var passwordNew = ref('');
        var passwordConfirm = ref('');
        var errorMessageNew = ref('');
        var isValid = reactive({
            passwordNew: false,
            passwordConfirm: false,
            checkPassword: true,
        });
        var isClearSubmit = computed(function () {
            return !(isValid.passwordNew && isValid.passwordConfirm && isValid.checkPassword);
        });
        var updatePassword = function (event) {
            passwordNew.value = event.value;
            isValid.passwordNew = event.isValid;
        };
        var confirmNewPassword = function (event) {
            passwordConfirm.value = event.value;
            isValid.passwordConfirm = event.isValid;
        };
        var checkPassword = function (event) {
            passwordConfirm.value = event.value;
            isValid.passwordConfirm = event.isValid;
            errorMessageNew.value = '';
            if (passwordConfirm.value !== passwordNew.value) {
                isValid.checkPassword = false;
                errorMessageNew.value = '入力されたパスワードが一致しません';
            }
            else {
                isValid.checkPassword = true;
                errorMessageNew.value = '';
            }
        };
        var cancel = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                window.location.href = '/signin/';
                return [2 /*return*/];
            });
        }); };
        var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var result, err_1, passwordError;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isProcessing.value = true;
                        Object.assign('isValid', {
                            passwordNew: false,
                            passwordConfirm: false,
                            checkPassword: false,
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, profileStore.setNewPassword({
                                password: passwordNew.value, cid: String(cid), token: String(token)
                            })];
                    case 2:
                        result = _a.sent();
                        if (result.data.user) {
                            acknowledgementStore.showAcknowledgement({
                                code: result.data.code,
                                message: result.data.message,
                                to: '/signin/',
                            });
                        }
                        else {
                            isProcessing.value = false;
                            Object.assign('isValid', {
                                passwordNew: true,
                                passwordConfirm: true,
                                checkPassword: true,
                            });
                            acknowledgementStore.showAcknowledgement({
                                code: '#1010031',
                                message: result.data.message,
                                to: '/signin/',
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log('err', err_1);
                        passwordError = err_1.message;
                        if (passwordError == 'パスワードを入力してください') {
                            if (!passwordNew.value)
                                errorMessageNew.value = '新しいパスワードを入力してください';
                        }
                        else if (passwordError == 'パスワードは8文字以上入力してください') {
                            errorMessageNew.value = '8文字以上の半角英数字記号を入力してください';
                        }
                        isProcessing.value = false;
                        Object.assign('isValid', {
                            passwordNew: true,
                            passwordConfirm: true,
                            checkPassword: true,
                        });
                        acknowledgementStore.showAcknowledgement({
                            code: '#1010031',
                            message: '入力内容をお確かめください。',
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var buttonStyle = {
            backgroundColor: '#1565C0',
            color: 'white',
            fontSize: '14px',
            fontWeight: 'bold',
            border: 'none',
            width: '12.8rem',
            height: '3.6rem',
        };
        var buttonCancelStyle = {
            backgroundColor: '#FFF',
            color: '#1565C0',
            fontSize: '14px',
            fontWeight: 'bold',
            border: '1px solid #1565C0',
            width: '12.8rem',
            height: '3.6rem',
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("form", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(InputPassword, {
                            id: "password-new",
                            value: passwordNew.value,
                            required: true,
                            isCurrentPassword: false,
                            placeholder: "新しいパスワード",
                            onUpdateValue: updatePassword,
                            onCheckTextLength: updatePassword
                        }, null, 8, ["value"]),
                        _createVNode(InputPassword, {
                            class: "mt-8",
                            id: "password-confirm",
                            value: passwordConfirm.value,
                            required: true,
                            isCurrentPassword: false,
                            placeholder: "新しいパスワード（確認）",
                            onUpdateValue: confirmNewPassword,
                            onCheckTextLength: checkPassword
                        }, null, 8, ["value"]),
                        (errorMessageNew.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessageNew.value), 1))
                            : _createCommentVNode("", true),
                        _hoisted_5
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(Button, {
                                class: "hover",
                                text: "キャンセル",
                                buttonStyle: buttonCancelStyle,
                                onOnDoAction: cancel
                            })
                        ]),
                        _createElementVNode("div", null, [
                            _createVNode(Button, {
                                class: "hover",
                                text: "保存",
                                buttonStyle: buttonStyle,
                                onOnDoAction: handleSubmit,
                                disabled: isClearSubmit.value
                            }, null, 8, ["disabled"])
                        ])
                    ])
                ]),
                _createVNode(LoadingProcessing, {
                    class: "z-[100] opacity-70 fixed bottom-0 left-0 right-0 top-0 flex items-center justify-center w-full h-full",
                    "is-loading": isProcessing.value,
                    "animate-class": "animate-pulse"
                }, null, 8, ["is-loading"]),
                _createVNode(Snackbars),
                _createVNode(AlertDialog)
            ], 64));
        };
    }
});
